// Organization types for eFiling party (organization mode)
export const ORGANIZATION_TYPES = [
    { code: 'ENTITY_OTHER', name: 'Other Commercial Entity' },
    { code: 'GOVERNMENT_AGENCY', name: 'Government Agency' },
    { code: 'TRUST', name: 'Trust' },
];
